import { convertToFloat } from '../../utilities/convertToFloat';
import { sum } from '../../utilities/sum';
import { IAPIFeeData } from '../../../types/clientPortal/Fees/IAPIFee';
import { ITotals } from '../interfaces/ITotals';
import { ICDV3ViewItem } from '../interfaces/ICDViewItem';

export const generateTotals = (items: ICDV3ViewItem[]): ITotals => {
  /*tslint:disable:variable-name*/
  const buyer_at_closing =
    items
      .map((item) => item.buyer_at_closing)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const buyer_before_closing =
    items
      .map((item) => item.buyer_before_closing)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const seller_at_closing =
    items
      .map((item) => item.seller_at_closing)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const seller_before_closing =
    items
      .map((item) => item.seller_before_closing)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const paid_by_others =
    items
      .map((item) => item.paid_by_others)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const buyer_paid = (buyer_before_closing || 0) + (buyer_at_closing || 0) || 0;
  const seller_paid = (seller_before_closing || 0) + (seller_at_closing || 0) || 0;
  /*tslint:enable:variable-name*/

  return {
    buyer_at_closing,
    buyer_before_closing,
    buyer_paid,
    paid_by_others,
    seller_at_closing,
    seller_before_closing,
    seller_paid,
  };
};

export const generateTotalsForIAPIFeeData = (items: IAPIFeeData[]): ITotals => {
  /*tslint:disable:variable-name*/
  const buyer_at_closing =
    items
      .map((item) => item.buyerAtClosing)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const buyer_before_closing =
    items
      .map((item) => item.buyerBeforeClosing)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const seller_at_closing =
    items
      .map((item) => item.sellerAtClosing)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const seller_before_closing =
    items
      .map((item) => item.sellerBeforeClosing)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const paid_by_others =
    items
      .map((item) => item.paidByOthersTotal)
      .map(convertToFloat)
      .reduce(sum, 0) || 0;
  const buyer_paid = (buyer_before_closing || 0) + (buyer_at_closing || 0) || 0;
  const seller_paid = (seller_before_closing || 0) + (seller_at_closing || 0) || 0;
  /*tslint:enable:variable-name*/

  return {
    buyer_at_closing,
    buyer_before_closing,
    buyer_paid,
    paid_by_others,
    seller_at_closing,
    seller_before_closing,
    seller_paid,
  };
};
